import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps, MenuItem } from '@mui/material';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var _templateObject;

var _excluded = ["className", "sx", "variant"];
var componentRoot = createComponentSlot({
  name: "CinTableMenuItem",
  slot: "Root"
});

var MenuCellItemBase = function MenuCellItemBase(_ref) {
  var className = _ref.className;
      _ref.sx;
      _ref.variant;
      var props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(MenuItem, _extends({}, props, {
    className: classnames(componentRoot.className, className)
  }));
};

MenuCellItemBase.propTypes = {
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
};
var MenuCellItemRoot = styled(MenuCellItemBase, componentRoot.styledOptions)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
/**
 * A single item for a table menu cell
 */

var MenuCellItem = function MenuCellItem(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(MenuCellItemRoot, rootProps);
};

var MenuCellItem$1 = MenuCellItem;

export { MenuCellItem$1 as default };
